import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-close-x-icon',
  templateUrl: './close-xicon.component.html',
  styleUrls: ['./close-xicon.component.scss']
})
export class CloseXIconComponent {


  @Input() stroke: string = '#1A1A1C'

  constructor() { }


}
